<div class="innerWrapper mb-5">
    <p>This is Belair Test Payment Rule Rule number 47 using payment gateway.</p>
</div>
